import { Grid } from '@mui/material';
import { FC } from 'react';
import {
  Create,
  Edit,
  SimpleForm,
  TextInput,
  NumberInput,
  BooleanInput,
  DateTimeInput,
  ArrayInput,
  SimpleFormIterator,
  SelectInput,
  required,
  ReferenceInput,
  FormDataConsumer,
} from 'react-admin';

const transformData = (data: any) => {
  if (Array.isArray(data.blocks)) {
    data.blocks = data.blocks.map((block: any, index: number) => ({
      ...block,
      position: index + 1,
    }));
  }
  if (Array.isArray(data.author.urls)) {
    data.author.urls = data.author.urls.map((block: any, index: number) => ({
      ...block,
      position: index + 1,
    }));
  }
  if (Array.isArray(data.material_urls)) {
    data.material_urls = data.material_urls.map(
      (block: any, index: number) => ({
        ...block,
        position: index + 1,
      })
    );
  }
  return data;
};

export const MaterialCreate = (props: any) => (
  <Create {...props} transform={transformData}>
    <SimpleForm>
      {/* Основные поля материала */}
      {/* <TextInput source="feed_id" label="Feed ID" validate={required()} /> */}
      <ReferenceInput source="feed_id" reference="feeds" label="Лента">
        <SelectInput source="id" label="Лента" fullWidth optionText="name" />
      </ReferenceInput>
      <NumberInput
        source="time_min"
        label="Время изучения"
        fullWidth
        validate={required()}
      />

      <SelectInput
        source="type"
        label="Тип публикации"
        fullWidth
        choices={[
          { id: 'post', name: 'Пост' },
          { id: 'lesson', name: 'Урок' },
          { id: 'advertismant', name: 'Реклама' },
        ]}
        validate={required()}
      />
      <TextInput
        source="url"
        label="Адрес (example_page_link)"
        fullWidth
        validate={required()}
      />
      <TextInput
        source="name"
        label="Название"
        fullWidth
        validate={required()}
      />
      <TextInput source="short_name" label="Короткое Название" fullWidth />
      <TextInput
        source="preheder_html"
        fullWidth
        minRows={3}
        maxRows={10}
        label="Контент прехедера"
        multiline
      />
      <TextInput
        source="preheder_img_url"
        label="Ссылка на прехедер (старый вариант)"
        fullWidth
      />
      <TextInput
        source="preview_img_url"
        label="Ссылка на превью картинку (новый вариант)"
        fullWidth
      />
      <BooleanInput
        source="is_only_subscription"
        label="Только по подписке"
        fullWidth
      />
      <FormDataConsumer>
        {({ formData, ...rest }) =>
          !formData.is_only_subscription && (
            <NumberInput source="cost" label="Стоимость" fullWidth {...rest} />
          )
        }
      </FormDataConsumer>
      <BooleanInput source="is_video" label="Есть видео" />
      <BooleanInput source="is_text" label="Есть текст" />
      <BooleanInput source="is_audio" label="Есть аудио" fullWidth />
      <BooleanInput source="is_publish" label="Опубликовано" fullWidth />
      <BooleanInput source="is_fixed" label="Закреплен наверху" fullWidth />
      <DateTimeInput source="publish_at" label="Дата публикации" fullWidth />
      <h3>Информация об авторе</h3>
      {/* Автор */}
      <TextInput
        source="author.name"
        label="Имя Автора"
        validate={required()}
        fullWidth
      />
      <TextInput
        source="author.description"
        label="Описание автора"
        fullWidth
        multiline
      />
      <TextInput
        source="author.image_url"
        label="Ссылка на изображение автора"
        fullWidth
      />
      <ArrayInput source="author.urls" label="Author URLs">
        <SimpleFormIterator inline>
          <SelectInput
            source="type"
            label="Соцсеть"
            choices={[
              { id: 'twitter', name: 'Twitter' },
              { id: 'instagram', name: 'Instagram' },
              { id: 'telegram', name: 'Telegram' },
              { id: 'other', name: 'Другое' },
            ]}
          />
          <TextInput source="url" label="Ссылка" />
          <TextInput source="name" label="Название" />
          <NumberInput
            source="position"
            label="Позиция"
            style={{ display: 'none' }}
          />
        </SimpleFormIterator>
      </ArrayInput>
      <h3>Контент</h3>
      {/* Блоки */}
      <ArrayInput source="blocks" label="Блоки с контентом">
        <SimpleFormIterator>
          <NumberInput
            source="position"
            label="Позиция"
            style={{ display: 'none' }}
          />
          <TextInput source="id" style={{ display: 'none' }} />
          <SelectInput
            fullWidth
            source="type"
            label="Тип контента"
            choices={[
              { id: 'text', name: 'Блок текста' },
              { id: 'audio', name: 'Аудио' },
              { id: 'header1', name: 'Заголовок 1' },
              { id: 'header2', name: 'Заголовок 2' },
              { id: 'header3', name: 'Заголовок 3' },
              { id: 'image', name: 'Изображение' },
              { id: 'video', name: 'Видео' },
              { id: 'checkbox', name: 'Чекбокс' },
            ]}
            validate={required()}
          />
          <BooleanInput
            source="is_blur"
            label="Размытие контента для не зареганных"
            defaultValue={true}
            fullWidth
          />
          <FormDataConsumer>
            {({ scopedFormData, getSource }) =>
              scopedFormData &&
              (scopedFormData.type === 'text' ||
                scopedFormData.type === 'header1' ||
                scopedFormData.type === 'header2' ||
                scopedFormData.type === 'header3' ||
                scopedFormData.type === 'checkbox') && (
                <TextInput
                  source={getSource('content')}
                  label="Контент"
                  multiline
                  fullWidth
                  minRows={3}
                  maxRows={10}
                />
              )
            }
          </FormDataConsumer>

          <FormDataConsumer>
            {({ scopedFormData, getSource }) =>
              scopedFormData &&
              (scopedFormData.type === 'audio' ||
                scopedFormData.type === 'image' ||
                scopedFormData.type === 'video') && (
                <TextInput source={getSource('url')} label="Ссылка" fullWidth />
              )
            }
          </FormDataConsumer>
          <FormDataConsumer>
            {({ scopedFormData, getSource }) =>
              scopedFormData &&
              scopedFormData.type === 'video' && (
                <TextInput
                  source={getSource('preview_url')}
                  label="Шапка для видео"
                  fullWidth
                />
              )
            }
          </FormDataConsumer>
          <FormDataConsumer>
            {({ scopedFormData, getSource }) =>
              scopedFormData &&
              scopedFormData.type === 'video' && (
                <ArrayInput source={getSource('timecodes')} label="Таймкоды">
                  <SimpleFormIterator inline>
                    <NumberInput
                      source={getSource('time')}
                      label="Время (сек)"
                      validate={required()}
                    />
                    <TextInput
                      source={getSource('name')}
                      label="Метка"
                      validate={required()}
                    />
                  </SimpleFormIterator>
                </ArrayInput>
              )
            }
          </FormDataConsumer>
        </SimpleFormIterator>
      </ArrayInput>

      <h3>Материалы</h3>
      {/* Блоки */}
      <ArrayInput source="material_urls" label="Ссылки на материалы">
        <SimpleFormIterator inline>
          <NumberInput
            source="position"
            label="Позиция"
            style={{ display: 'none' }}
          />
          <TextInput source="url" label="Ссылка" />
          <TextInput source="name" label="Название" />
        </SimpleFormIterator>
      </ArrayInput>
    </SimpleForm>
  </Create>
);
